module.exports = __webpack_public_path__ + "img/effects-3.9357ddf7.png";